import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import DropdownTitle from '../dropdown/DropdownTitle'

function normalizeCategories (categories, onFilterChange) {
  return categories
    .filter(parent => parent.categories)
    .map(parent => {
      return {
        groupName: parent.groupName,
        items: parent.categories.map(child => {
          return {
            title: child.categoryName,
            value: child.categoryId,
            onClick: onFilterChange
          }
        })
      }
    })
}

const CategorySelector = ({ categories, selected, onFilterChange }) => {
  categories = normalizeCategories(categories, onFilterChange)
  return <DropdownControl
    isGrouped
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <DropdownTitle label={'Category'} title={selected} /> : 'Select a category'} class={'filter qa-category-filter'} icon={'arrowDropdown'} />}
    items={categories}
  />
}

export default CategorySelector
